// Canonical motion durations (ms) shared by both platforms.
export const MotionDurations = {
  /** Micro feedback: press scale, hover transitions. */
  fast: 120,
  /** Standard UI transitions: toasts, fades, dropdowns. */
  normal: 200,
  /** Overlay entrances: sheets, dialogs. */
  slow: 300,
} as const;

/**
 * Chart scan (hold-to-scan / hover-scan) activation delay. Matches
 * VICTORY_CHART_PRESS_CONFIG.pan.activateAfterLongPress on mobile so scroll
 * is never hijacked; web pointer scan uses it for touch parity.
 */
export const CHART_SCAN_ACTIVATION_MS = 120;

export type T_MotionDurationToken = keyof typeof MotionDurations;
